import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import UiDialogTitle from 'ui-components/ui-dialog-title/UiDialogTitle';
import UiDialogContent from 'ui-components/ui-dialog-content/UiDialogContent';
import { UiDialogActions, UiButton } from 'ui-components';
import { useApi } from 'hooks';
import Loading from 'components/loading/Loading';
import { changeNewVersionModalState } from 'store';
import { StyledVersionListDialog } from './VersionList.styles';

const VersionList = () => {
  const dispatch = useDispatch();
  const { data, loading, get, add, getApiParams } = useApi();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const newVersion = useSelector(
    (state) => state.notificationReducer.newVersion
  );
  const isNewVersionModalOpen = useSelector(
    (state) => state.notificationReducer.isNewVersionModalOpen
  );
  const navigate = useNavigate();

  /**
   * بستن مودال و سین شدن ورژن ها
   * @param {*} response
   */
  const handleClose = (response) => {
    const { path } = getApiParams('versionSeen');
    const ids = response?.map((x) => x.id);
    add(path, { ids }, null).then(() => {});
  };

  /**
   * دریافت دیتای مربوط به ورژن ها
   */
  const getDate = () => {
    setVisible(true);
    const { path, params } = getApiParams('versionCheck');
    get(path, { ...params }, null).then((response) => {
      localStorage.setItem('seen-version', response[0]?.version_name);
      if (response?.length <= 0) {
        dispatch(changeNewVersionModalState(false));
        return;
      }
      handleClose(response);
    });
  };

  // useEffect(() => {
  //   // اگه برای اولین بار کاربر وارد سامانه بشه یا اولین بار باشه که لاگین میکنه، فرایند ادامه پیدا میکنه
  //   if (!localStorage.getItem("seen-version")) {
  //     getDate();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    // اگه آخرین ورزن دریافت شده با آخرین ورژنی که کاربر دیده بود مغایرت داشت فرایند ادامه پیدا میکنه
    if (localStorage.getItem('seen-version') !== newVersion) {
      dispatch(changeNewVersionModalState(true));
      getDate();
    } else if (isNewVersionModalOpen) {
      dispatch(changeNewVersionModalState(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newVersion]);

  //   اگر قبلا ورژن را دیده بود دیگر اجرا نشود
  if (!visible || data?.length <= 0) return null;

  return (
    <StyledVersionListDialog open={visible} className='version-list'>
      <UiDialogTitle>
        <div>{t('changelog:applicationChanges')}</div>
        <div>
          <UiIcon
            className='close-icon'
            icon='ri-close-line'
            onClick={() => {
              setVisible((x) => !x);
              dispatch(changeNewVersionModalState(false));
            }}
          />
        </div>
      </UiDialogTitle>
      <UiDialogContent>
        <Loading spinning={loading}>
          {data?.[0] && (
            <>
              <div className='version-name'>
                {t('changelog:version', {
                  versionNumber: data?.[0]?.version_name,
                })}
              </div>
              {data?.[0]?.features?.map((x) => (
                <ul key='' className='flex version-list-item '>
                  <li className='version-description'>
                    <span>{x?.description}</span>{' '}
                    {x?.link && (
                      <a
                        className='version-link'
                        href={x?.link}
                        target='_blank'
                        rel='noreferrer'
                      >
                        <span>{t('changelog:knowMore')}</span>
                      </a>
                    )}
                  </li>
                </ul>
              ))}
            </>
          )}
        </Loading>
      </UiDialogContent>

      <UiDialogActions>
        <UiButton
          onClick={() => {
            dispatch(changeNewVersionModalState(false));
            navigate('/changelog');
          }}
          style={{ color: 'white' }}
        >
          {t('changelog:versionHistory')}
        </UiButton>
      </UiDialogActions>
    </StyledVersionListDialog>
  );
};

export default VersionList;
